export interface HelpApp {
	id: string;
	name: string;
	icon: string;
	categoryOrder: string[];
}

export const helpApps: HelpApp[] = [
	{
		id: 'my-hahnemuehle',
		name: 'My Hahnemühle',
		icon: 'fill-hahnemuehle',
		categoryOrder: [
			'Hahnemühle ID',
			'Password and Security',
			'Account Settings',
			'Excellence Program',
			'Partnership with Hahnemühle',
			'Deleting your account',
			'Subscriptions',
			'Payments and Invoices',
			'Earnings',
		],
	},
	{
		id: 'my-art-registry',
		name: 'My Art Registry',
		icon: 'fill-my-art-registry',
		categoryOrder: [
			'General',
			'Other',
		],
	},
];

export function findHelpApp(id?: string) {
	if (!id) { return undefined; }
	return helpApps.find(a => a.id === id);
}
